import { useMemo } from 'react';
import { createResourceAtom } from 'lib/atoms';
import type {
  DivisionOrderDetailResponse,
  DivisionOrderLineItemsResponse,
} from './types';

const useDivisionOrderAtom = (id: string) =>
  useMemo(
    () =>
      createResourceAtom<DivisionOrderDetailResponse>(`/division_orders/${id}`),
    [id]
  );

// Page/perPage flow through query params — the BE uses Kaminari (`.page().per()`)
// so `?page=X&per_page=Y` paginates the response. Re-keying useMemo on
// id/page/pageSize recreates the atom on each change, which fires a fresh GET.
const useDivisionOrderLineItemsAtom = (
  divisionOrderId: string,
  page: number,
  pageSize: number
) =>
  useMemo(
    () =>
      createResourceAtom<DivisionOrderLineItemsResponse>(
        `/division_orders/${divisionOrderId}/line_items?page=${page}&per_page=${pageSize}`
      ),
    [divisionOrderId, page, pageSize]
  );

export { useDivisionOrderAtom, useDivisionOrderLineItemsAtom };
